<div *ngIf="isLoading" class="outer-spinner">
  <div class="loading-spinner"></div>
</div>

<form *ngIf="!isLoading" (ngSubmit)="saveChanges()">

  <div class="pcard">
    <h2><i class="fa-solid fa-briefcase"></i> Work &amp; Business</h2>
    <div class="grid-2">
      <div class="fld">
        <label for="company">Company</label>
        <input type="text" id="company" [(ngModel)]="user.company" name="company" placeholder="Company Name" autocomplete="off" />
      </div>
      <div class="fld">
        <label for="job_title">Job Title</label>
        <input type="text" id="job_title" [(ngModel)]="user.job_title" name="job_title" placeholder="Designation Name" autocomplete="off" />
      </div>
      <div class="fld span-2">
        <label for="website">Website</label>
        <input type="text" id="website" [(ngModel)]="user.website" name="website" placeholder="Website Address" autocomplete="off" />
      </div>
    </div>
  </div>

  <div class="pcard">
    <h2><i class="fa-solid fa-share-nodes"></i> Social Media</h2>
    <div class="grid-2">
      <div class="fld">
        <label for="facebook_url">Facebook URL</label>
        <input type="text" id="facebook_url" [(ngModel)]="user.facebook_url" name="facebook_url" placeholder="https://facebook.com/..." autocomplete="off" />
      </div>
      <div class="fld">
        <label for="twitter_url">Twitter URL</label>
        <input type="text" id="twitter_url" [(ngModel)]="user.twitter_url" name="twitter_url" placeholder="https://twitter.com/..." autocomplete="off" />
      </div>
      <div class="fld">
        <label for="linkedin_url">LinkedIn URL</label>
        <input type="text" id="linkedin_url" [(ngModel)]="user.linkedin_url" name="linkedin_url" placeholder="https://linkedin.com/in/..." autocomplete="off" />
      </div>
      <div class="fld">
        <label for="youtube_url">YouTube URL</label>
        <input type="text" id="youtube_url" [(ngModel)]="user.youtube_url" name="youtube_url" placeholder="https://youtube.com/..." autocomplete="off" />
      </div>
    </div>

    <div class="actions">
      <button type="submit" class="btn-pink" [disabled]="saving">
        <i class="fa-solid fa-floppy-disk"></i> {{ saving ? 'Saving...' : 'Save Changes' }}
      </button>
      <span class="note" *ngIf="saveMsg" [class.ok]="saveOk" [class.bad]="!saveOk">{{ saveMsg }}</span>
    </div>
  </div>

</form>
